export const getReleaseStatus = approvalType => {
  switch (approvalType) {
    default:
      return null;
  }
};